import {HTTP} from '@/services/HttpServices';
import {Form, FormSubmission} from '@/FormModels';

const FORM_PATH = '/public/forms';
const FORM_SUBMISSION_PATH = '/public/form-submissions';
const FORM_SUBMISSION_PDF_PATH = '/public/form-submissions/pdfs';
const FORM_SUBMISSION_ERROR_PATH = '/public/form-submissions/error';

export async function getFormByName(name: string): Promise<Form> {
    return await HTTP.get(`${FORM_PATH}?name=${name}`);
}

export async function getFormSubmission(token: string) {
    return await HTTP.get(`${FORM_SUBMISSION_PATH}?formToken=${token}`);
}

export async function createFormSubmission(formSubmission: FormSubmission) {
    return await HTTP.post(FORM_SUBMISSION_PATH, formSubmission);
}

export async function updateFormSubmission(formSubmission: FormSubmission) {
    return await HTTP.put(`${FORM_SUBMISSION_PATH}/${formSubmission.id}`, formSubmission);
}

export async function downloadFormSubmission(formSubmissionId: string) {
    return await HTTP.postExpectingBlob(FORM_SUBMISSION_PDF_PATH, {formSubmissionId});
}

export async function logCustomFormError(error: Error) {
    return await HTTP.post(FORM_SUBMISSION_ERROR_PATH, {error: {
        message: error.message,
        stack: error.stack,
        name: error.name
    }});
}

